import React from 'react';
import '../styles/backdrop.css';

/* Fixed atmosphere behind the whole page: aurora blobs + grid + film grain. */
const Backdrop = () => (
  <div className="backdrop" aria-hidden="true">
    <div className="aurora aurora--1" />
    <div className="aurora aurora--2" />
    <div className="aurora aurora--3" />
    <div className="backdrop-grid" />
    <div className="backdrop-grain" />
    <div className="backdrop-vignette" />
  </div>
);

export default Backdrop;
